import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
const sanitisePathSegment = (text)=>text ? text.replace(/\s+/g, "-").replace(/\[/g, "(").replace(/]/g, ")").toLowerCase() : "";
export const productDetailUrl = (vehicle)=>{
    if (!vehicle || !vehicle.make || !vehicle.model || !vehicle.id) {
        return "/used-cars";
    }
    return `/used-cars/${sanitisePathSegment(vehicle.make)}/${sanitisePathSegment(vehicle.model)}/details/${vehicle.id}`;
};
export const LinkToProductDetail = ({ children , basicVehicleInfo , className  })=>/*#__PURE__*/ _jsx("a", {
        href: productDetailUrl(basicVehicleInfo),
        target: "_blank",
        "aria-label": `Open the car detail page in a new browser tab`,
        rel: "noreferrer",
        className: className,
        children: children
    });
